/**
 * Which plan the mocked agency holds — PLN-1's two values (`Docs` is the
 * baseline, `DocsEvidence` adds Evidence on top of it).
 *
 * Module-level state for the same reason as `mockPersona.ts` beside it: the
 * readers are the `/me` and `/storage` handlers in `test/mocks/handlers.ts`,
 * which run inside the MSW worker, entirely outside React. `MockPlanSwitch` in
 * `App.tsx` is the one writer — it also calls `useMe`'s `retry` after every
 * change, since flipping this value alone does not refetch anything.
 *
 * `DocsEvidence` is the default because that is what SMPSD holds in both
 * fixture sets, and the Storage surface's Evidence-only lines are the visible
 * difference this switch exists to show.
 *
 * Meaningless, and never rendered, once `VITE_USE_MOCKS` is off: there are no
 * mock handlers to read it, and the real API reports the agency's own plan.
 */
export type MockPlan = 'Docs' | 'DocsEvidence';

let current: MockPlan = 'DocsEvidence';

export function getMockPlan(): MockPlan {
  return current;
}

export function setMockPlan(plan: MockPlan): void {
  current = plan;
}

/** Test-only: no test may leave the plan changed for the next one. */
export function resetMockPlan(): void {
  current = 'DocsEvidence';
}
